import { trackContact, trackLead } from '@/utils/fbPixel';

export default function ContactoSection() {
  return (
    <section id="contacto" className="bg-black py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
        <span className="text-[#E10600] text-xs font-black uppercase tracking-widest mb-4 block">
          Atención al cliente
        </span>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-4">
          Atención exclusiva por WhatsApp
        </h2>
        <p className="text-white/60 text-base md:text-lg mb-12 max-w-xl mx-auto">
          Para brindarte la mejor asesoría, atendemos únicamente por WhatsApp. Respuesta rápida y personalizada.
        </p>

        {/* WhatsApp icon */}
        <div className="w-24 h-24 flex items-center justify-center bg-[#25D366] rounded-full mx-auto mb-10 shadow-lg shadow-green-900/30">
          <i className="ri-whatsapp-line text-white text-5xl"></i>
        </div>

        {/* Phone numbers */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
          <a
            href="https://wa.link/rb4jxv"
            target="_blank"
            rel="nofollow noreferrer"
            onClick={() => { trackContact(); trackLead(); }}
            className="flex items-center gap-3 bg-[#E10600] hover:bg-red-700 text-white font-black text-xl md:text-2xl px-8 py-4 rounded-xl transition-all duration-200 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            301 706 2478
          </a>
          <a
            href="https://wa.link/szf6pp"
            target="_blank"
            rel="nofollow noreferrer"
            onClick={() => { trackContact(); trackLead(); }}
            className="flex items-center gap-3 bg-[#E10600] hover:bg-red-700 text-white font-black text-xl md:text-2xl px-8 py-4 rounded-xl transition-all duration-200 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            302 533 0081
          </a>
        </div>

        {/* Schedule */}
        <div className="inline-flex items-center gap-3 bg-white/5 border border-white/10 rounded-xl px-8 py-4">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-time-line text-[#E10600] text-xl"></i>
          </div>
          <div className="text-left">
            <div className="text-white font-bold text-sm">Horario de atención</div>
            <div className="text-white/60 text-sm">Lunes a Viernes &bull; 8:00 am – 5:00 pm</div>
            <div className="text-white/60 text-sm">Sábados &bull; 8:00 am – 12:00 pm</div>
          </div>
        </div>
      </div>
    </section>
  );
}
